const STREAM_ON = 'streamStatus/STREAM_ON'
const STREAM_OFF = 'streamStatus/STREAM_OFF'

export const streamOn = () => ({ type: STREAM_ON })
export const streamOff = () => ({
  type: STREAM_OFF,
})

type StreamAction = ReturnType<typeof streamOn> | ReturnType<typeof streamOff>
type StreamState = {
  stream: string
}
export const initialState: StreamState = {
  stream: '',
}

export default function streamStatus(state: StreamState = initialState, action: StreamAction) {
  switch (action.type) {
    case STREAM_ON:
      return {
        ...state,
        stream: 'on',
      }
    case STREAM_OFF:
      return {
        ...state,
        stream: 'off',
      }
    default:
      return state
  }
}
